<script>
import mixinComponent from '../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../Mixins/global'
import ModalDialog from '../UI/Modal/ModalDialog.vue'
import ButtonAll from '../UI/Button/ButtonAll.vue'
import MessageForm from './MessageForm.vue'

export default {
  components: { MessageForm, ButtonAll, ModalDialog },
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    title: { type: String },
    context: { type: String, required: true },
    contextId: { type: Number, required: true },
    provider: { type: String, default: null },
    messageId: { type: String, default: '', required: false },
    active: { type: String, default: 'OK' },
    open: { type: Boolean, default: false },
    hide: { type: Boolean, default: false },
    apiCall: { type: Boolean, default: false },
    contextValidate: { type: Boolean, default: false },
    mandatoryAttachment: { type: Boolean, default: false },
    additionalContexts: { type: Array, default: [], required: false },
  },

  data() {
    return {
      filename: null,
      isMessageReceive: false,
      message: {},
      messages: [],
      opening: false,
      isFirstLoad: true,
    }
  },

  computed: {
    openContentClasses() {
      return {
        'mt-2': true,
        collapse: !this.open,
      }
    },
  },

  methods: {
    getEnvelopeClass(status) {
      let base = 'fa fa-envelope'
      switch (status) {
        case 'CREATED':
          base = 'fas fa-envelope-square text-info'
          break
        case 'SENT':
          base += ' text-warning'
          break

        case 'DRAFT':
          base = 'fas fa-envelope-square text-info'
          break

        case 'RECEPTED':
          base += '-open'
        case 'ACCEPTED':
        case 'DEPOSED':
          base += ' text-success'
          break

        case 'CANCELED':
        case 'SPAM':
        case 'ERROR':
        case 'PND':
          base += ' text-danger'
          break
      }

      return base
    },

    sendMessageUp(event) {
      this.$emit('message-sent', {
        message: event,
      })

      if (this.apiCall) {
        this.callbackMessage()
      }
    },
    getMess(index, message = null) {
      let iframe = this.$refs['iframe' + index][0]
      const iframeDocument = iframe.contentDocument || iframe.contentWindow.document
      iframeDocument.body.innerHTML = message ? message.body : ''

      if (message.media === 'EXTERNAL') {
        iframeDocument.body.style.whiteSpace = 'pre'
      }

      $('#modal-view-message' + index).modal('show')
    },
    async download(id, label) {
      await this.downloadFile(`documents/${id}/download`, `${label}.pdf`)
    },
    closeModal() {
      const pdfModal = document.getElementById('pdf')
      const iframe = pdfModal.querySelector('iframe')
      pdfModal.removeChild(iframe)
      $('#modal-pdf').modal('hide')
    },
    async openModal(id) {
      let url = ''
      if (this.uuid) {
        url += 'free/'
      }
      url += `documents/${id}/download`

      try {
        const fileContent = await this.getFile(url)

        const dataUrl = window.URL.createObjectURL(fileContent)

        const iframe = document.createElement('iframe')
        iframe.src = dataUrl
        iframe.width = '100%'
        iframe.height = '500px'
        const pdfModal = document.getElementById('pdf')
        pdfModal.appendChild(iframe)

        // show the modal
        $('#modal-pdf').modal('show')
      } catch (error) {
        this.toast(this.$t('document.modal.titleError'))
      }
    },
    pageValidation() {
      this.$emit('page-validation')
    },
    callbackMessage() {
      const query = new URLSearchParams({
        context: this.context,
        contextId: this.contextId,
      })

      this.getJSON(`messages?${query.toString()}`).then((json) => {
        this.messages = json
        if (this.isFirstLoad === false) {
          this.$emit('update')
        }
        this.isFirstLoad = false
      })
    },
    getRecipientTobccTranslation(recipient) {
      return this.$t('message.fields.tobcc.' + recipient.tobcc)
    },
  },

  mounted() {
    $('.card-header').click(function () {
      $(this).find('i').toggleClass('fas fa-plus fas fa-minus')
    })

    if (this.apiCall) {
      this.callbackMessage()
    }
  },
}
</script>
<template>
  <div class="mt-2">
    <div v-if="!open" class="row">
      <div class="col-xl-9 col py-1 d-flex">
        <MessageForm
          v-if="!user.isReadOnly && active != 'CANCELED'"
          ref="messageForm"
          :context="context"
          :context-id="contextId"
          :additional-contexts="additionalContexts"
          :context-validate="contextValidate"
          :media="provider != null ? 'EXTERNAL' : 'EMAIL'"
          :hide="hide"
          @message-sent="sendMessageUp"
        />
      </div>
      <div class="col-xl-3 col d-flex py-1">
        <div class="bg-info perfect-cercle">
          {{ Object.keys(messages).length }}
        </div>
        <button
          v-if="Object.keys(messages).length > 0"
          type="button"
          class="btn card-header"
          data-toggle="collapse"
          data-target="#mymessage"
          e2e-button="toggleMessages"
        >
          <i class="fa fa-plus"></i>
        </button>
      </div>
    </div>
    <MessageForm
      v-if="!user.isReadOnly && active != 'CANCELED' && open"
      ref="messageForm"
      :context="context"
      :context-id="contextId"
      :additional-contexts="additionalContexts"
      :context-validate="contextValidate"
      :media="provider != null ? 'EXTERNAL' : 'EMAIL'"
      :hide="hide"
      @message-sent="sendMessageUp"
    />
    <ModalDialog id="modal-pdf" class-modal-dialog="modal-xl" @icon-close="closeModal" e2e-modal="pdf">
      <template #body>
        <div class="form-group row" id="pdf"></div>
      </template>
      <template #footer>
        <div class="mt-3">
          <button type="button" class="btn btn-lg btn-primary" @click="closeModal" e2e-button="close">
            {{ $t('main.close') }}
          </button>
        </div>
      </template>
    </ModalDialog>
    <div id="mymessage" :class="openContentClasses" style="overflow-x: auto" v-if="Object.keys(messages).length > 0">
      <table class="table table-bordered">
        <tbody ref="tableMessage">
          <template v-for="(message, index) in messages">
            <tr class="messages-header">
              <td>
                {{ message.media }}
              </td>
              <td>
                <MessageForm
                  v-if="!user.isReadOnly && message.showPrepareMessage"
                  :ref="'messageForm' + message.id"
                  :context="context"
                  :context-id="contextId"
                  :additional-contexts="additionalContexts"
                  :media="provider != null ? 'EXTERNAL' : 'EMAIL'"
                  :message-id="message.id"
                  :context-validate="contextValidate"
                  :hide="hide"
                  @message-sent="sendMessageUp"
                  @page-validation="pageValidation"
                />
                <button
                  v-if="!message.showPrepareMessage"
                  type="button"
                  class="btn p-2 btn-primary"
                  @click="getMess(index, message)"
                  style="cursor: pointer"
                  e2e-button="getMessage"
                >
                  <i class="fa fa-eye"></i>
                </button>
              </td>
              <td colspan="2">
                <b>{{ message.subject }}</b>
                <ModalDialog :id="'modal-view-message' + index" class-modal-dialog="modal-xl" e2e-modal="message">
                  <template #body>
                    <table class="table table-striped table-bordered fs-16">
                      <tbody>
                        <tr>
                          <td>{{ $t('message.subject.title') }}</td>
                          <td e2e-data="messageSubject">{{ message.subject }}</td>
                        </tr>
                        <tr>
                          <td>{{ $t('message.message') }}</td>
                          <td e2e-data="messageFrame">
                            <iframe :ref="'iframe' + index" width="800" height="600"></iframe>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </template>
                  <template #footer>
                    <ButtonAll
                      margin="no"
                      type="information"
                      data-dismiss="modal"
                      label="button.cancel"
                      name="cancel"
                    />
                  </template>
                </ModalDialog>
              </td>
            </tr>
            <tr v-for="recipient in message.recipients">
              <td>
                {{ getRecipientTobccTranslation(recipient) }}
              </td>
              <td colspan="2">
                <i :class="getEnvelopeClass(recipient.status)"></i>
                {{ recipient.name }}
              </td>
              <td>
                {{ recipient.address }}
              </td>
              <td>
                {{ $d(recipient.sentAt ? new Date(recipient.sentAt) : new Date(recipient.statusAt), 'datetime_short') }}
              </td>
            </tr>
            <tr v-if="message.attachments.length > 0">
              <td colspan="2">
                {{ $t('simulation.message.attachments') }}
              </td>
              <td colspan="2">
                <table>
                  <tr class="d-flex align-items-center" v-for="attachment in message.attachments" :key="attachment.id">
                    <td>
                      <i
                        class="fas fa-search"
                        @click="openModal(attachment.id, attachment.name)"
                        style="cursor: pointer"
                      ></i>
                      <ButtonAll
                        margin="no"
                        type="link"
                        icon="quote"
                        width="aligned"
                        truncated
                        :label="attachment.name"
                        @click="download(attachment.id, attachment.name)"
                        class="small text-nowrap"
                        name="downloadDocumentAttachment"
                      />
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>
